import {
    SET_ALL_FILES,
    SET_PROJECT_FILES,
    SET_ORIGINAL_FILENAME,
    SET_FILE_PROJECT_ID,
    SET_UPLOAD_FILE,
    SET_IS_LOADING,
} from './_types';

export default {
    [SET_ALL_FILES](state, data) {
        state.files.all = [...data];
    },
    [SET_PROJECT_FILES](state, data) {
        state.files.project = [...data];
    },
    [SET_ORIGINAL_FILENAME](state, originalFilename) {
        state.original_filename = originalFilename;
    },
    [SET_FILE_PROJECT_ID](state, projectId) {
        state.project_id = projectId;
    },
    [SET_UPLOAD_FILE](state, file) {
        state.file = file;
    },
    [SET_IS_LOADING](state, isLoading) {
        state.is_loading = isLoading;
    }
};



// WEBPACK FOOTER //
// ./src/infrastructure/fileuploads/store/_mutators.js